import "./TathyankSection.css";
import Data from "../../temp/Data.json";

function TathyankSection() {
  return (
    <div className="tathyank-section">
      <div className="tathyank-section__heading-box">
        <h2>हाम्रो तथ्यांक: हाम्रो पहिचान </h2>
      </div>
      <div className="tathyank-section__stats-box">
        {Data.stats.map((e) => (
          <div key={e.name} className="tathyank-section__stats">
            <h3 className="tathyank-section__stats-heading">{e.name}</h3>
            <img
              src={`assets/icons/${e.logo}`}
              alt="Piggy Bank Icon"
              className="tathyank-section__icon"
            />
            <p className="tathyank-section__stats-value">{e.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TathyankSection;
